import { Link } from 'react-router-dom'
import './BreadCrumbs.css'

export const BreadCrumbs=(props)=>{
    return (
    <nav className='breadcrum-tab w-100 bg-white px-2 px-sm-0' style={{"--bs-breadcrumb-divider":'>'}} aria-label="breadcrumb" id="SbaBreadCrumbs">
                <ol className="breadcrumb align-items-center m-0 px-sm-4 pb-2">
                      {props.Levels && props.Levels.map(Level=>(<li className="breadcrumb-item" key={Level.BreadCrumb}><Link className='text-decoration-none' to={Level.Routes}>{Level.BreadCrumb}</Link></li>))}
                </ol>
            </nav>
    )
}